import React, { useState, useEffect } from 'react';
import Layout from 'components/Layout';
import { Grid, Button, Container } from '@material-ui/core';
import i18n from 'i18n-js';
import Logs from 'components/Logs';
import Feature from 'components/Feature';
import {
  Actions,
  Snapshots,
  Statistics,
  SubscriptionStatistics,
  CalendarWidget,
  SubscriptionsNocCalendar,
} from 'components/Dashboard';
import Can from 'components/Can';
import Title from 'components/Title';
import { useSelector, useDispatch } from 'react-redux';
import useStyles from './Dashboard.styled';
import OrgAbility from 'components/OrgAbility';
import { AlarmsWidget } from 'components/Alarms';
import { ReservationModal } from 'components/Modals';
import { UserSettingsActions } from 'state/modules/userSettings';

const DashboardPage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [openReservationModal, setOpenReservationModal] = useState(false);
  const guidingModalOpen = useSelector((state) => state.userSettings?.guidingModalOpen);

  const { core } = useSelector((state) => state.config?.settings || {});

  useEffect(() => {
    if (guidingModalOpen === 'INIT') {
      dispatch(UserSettingsActions.handleShowGuidingModal(true));
    }
  }, [guidingModalOpen]);

  const handleOpenReservationModal = () => {
    setOpenReservationModal((prevState) => !prevState);
  };

  const createReservation = core?.reservation?.create;

  return (
    <Layout title="Dashboard">
      <Container className={classes.container}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid container spacing={2} direction="row" justifyContent="space-between">
              <Grid item>
                <Title dataCy="dashboard-title" title={i18n.t('dashboard.title')} />
              </Grid>
              {createReservation ? (
                <Feature name="reservation" is="enabled">
                  <Can I="create" a="reservation">
                    <Grid item>
                      <Button
                        color="primary"
                        variant="contained"
                        data-cy="create-reservation-btn"
                        onClick={() => {
                          handleOpenReservationModal();
                        }}
                        style={{ textTransform: 'inherit' }}
                      >
                        {i18n.t('reservations.create_new_reservation')}
                      </Button>
                    </Grid>
                  </Can>
                </Feature>
              ) : null}
            </Grid>
          </Grid>
          {!core?.subscription?.enabled ? (
            <>
              <Can I="read" on="vehicle_group">
                <Grid item xs={12}>
                  <Statistics type="reservations" />
                </Grid>
                <OrgAbility subject={['msServiceOrg', 'plainOrg']}>
                  <Grid item xs={12}>
                    <Snapshots type="reservations" />
                  </Grid>
                </OrgAbility>
              </Can>
              <Grid item xs={12}>
                <CalendarWidget />
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={12}>
                <SubscriptionStatistics />
              </Grid>
              <Grid item xs={12}>
                <SubscriptionsNocCalendar />
              </Grid>
              <Grid item xs={12}>
                <Actions />
              </Grid>
            </>
          )}
          <Grid item xs={12} md={8}>
            <Grid container spacing={3}>
              <Can I="read" on="conditional_instance">
                <Grid item xs={12} sm={12} md={6}>
                  <AlarmsWidget />
                </Grid>
              </Can>
            </Grid>
          </Grid>
          <Can I="read" on="event_log">
            <Grid item xs={12} md={4}>
              <Logs secondary={false} height={439} />
            </Grid>
          </Can>
        </Grid>
      </Container>
      {openReservationModal && (
        <ReservationModal open={openReservationModal} handleClick={handleOpenReservationModal} />
      )}
    </Layout>
  );
};

export default DashboardPage;
